module.exports = __webpack_public_path__ + "static/img/测速总速11.c8babeac.png";